import {
  Attachment,
  ClassroomEmentas,
  ClassroomSectionQuestionPercentage,
  ClassroomSubjectList,
  ClassroomTeacher,
  Res,
  Solicitator,
  StudentCalllist,
  Subject,
} from '@/types'

import base from './base'

export const classroomApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getClassroomSubjects: builder.query<ClassroomSubjectList[], void>({
      query: () => 'teachers/classroom-subjects',
      transformResponse: (res: Res<ClassroomSubjectList[]>) => res.data,
      providesTags: ['Classroom'],
    }),

    getClassroom: builder.query<ClassroomTeacher[], void>({
      query: () => 'teachers/classroom-teachers',
      transformResponse: (res: Res<ClassroomTeacher[]>) => res.data,
      providesTags: ['Classroom'],
    }),

    getStudents: builder.query<StudentCalllist[], number>({
      query: (subjectId) => `teachers/classroom-subjects/${subjectId}/calllist`,
      transformResponse: (res: Res<StudentCalllist[]>) => res.data,
    }),

    getEmentas: builder.query<ClassroomEmentas[], number>({
      query: (classroomSubjectId) =>
        `totvs/classroom-subjects/${classroomSubjectId}/menus`,
      transformResponse: (res: Res<ClassroomEmentas[]>) => res.data,
    }),

    attachments: builder.query<Attachment[], number>({
      query: (id) => `teachers/classroom-subjects/${id}/attachments`,
      transformResponse: (res: Res<Attachment[]>) => res.data,
      providesTags: ['Attachments'],
    }),

    attach: builder.mutation<Attachment, FormData>({
      query: (body) => ({
        url: 'teachers/attachments',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Classroom', 'TeachingSectionQuestions'],
    }),

    unattach: builder.mutation<void, { attachmentId: number }>({
      query: ({ attachmentId }) => ({
        url: `teachers/attachments/${attachmentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Classroom', 'TeachingSectionQuestions'],
    }),

    getSubjects: builder.query<Subject[], void>({
      query: () => 'subjects',
      transformResponse: (res: Res<Subject[]>) => res.data,
      providesTags: ['Subjects'],
    }),

    getClassroomQuestionProgress: builder.query<
      ClassroomSectionQuestionPercentage,
      string
    >({
      query: (id) => `teachers/classroom-subjects/${id}/questions/progress`,
      providesTags: ['ClassroomQuestionProgress'],
      transformResponse: (res: Res<ClassroomSectionQuestionPercentage>) => res.data,
    }),

    getSolicitations: builder.query<Solicitator[], number | string>({
      query: (classroomSubjectId) =>
        `teachers/classroom-subjects/${classroomSubjectId}/solicitations`,
      transformResponse: (res: Res<Solicitator[]>) => res.data,
      providesTags: ['Classroom'],
    }),
  }),
})

export const {
  useGetClassroomQuery,
  useGetClassroomSubjectsQuery,
  useGetStudentsQuery,
  useGetEmentasQuery,
  useAttachMutation,
  useUnattachMutation,
  useLazyGetStudentsQuery,
  useGetSubjectsQuery,
  useLazyGetClassroomSubjectsQuery,
  useGetClassroomQuestionProgressQuery,
  useGetSolicitationsQuery,
} = classroomApi
